import { render } from "./PendingGrading.vue?vue&type=template&id=0553ca52"
import script from "./PendingGrading.vue?vue&type=script&lang=js"
export * from "./PendingGrading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__